import { forwardRef } from 'react'
import {
  Bloom,
  EffectComposer,
  EffectComposerProps
  // Noise
} from '@react-three/postprocessing'
import {
  // BlendFunction,
  EffectComposer as EffectComposerImpl,
  KernelSize,
  Resolution
} from 'postprocessing'

const Effects = forwardRef<
  EffectComposerImpl,
  Omit<EffectComposerProps, 'children'>
>((props, ref) => {
  return (
    <EffectComposer
      ref={ref}
      enableNormalPass={false}
      enabled={false}
      {...props}
    >
      <Bloom
        mipmapBlur
        intensity={1.6}
        luminanceThreshold={1}
        width={Resolution.AUTO_SIZE}
        height={Resolution.AUTO_SIZE}
        kernelSize={KernelSize.MEDIUM}
      />

      {/* <Noise
        opacity={0.05} // opacity of the noise effect
        premultiply // enables or disables noise premultiplication
        blendFunction={BlendFunction.ADD} // blend mode
      /> */}
    </EffectComposer>
  )
})

export default Effects
